const customChrono = {
  props: {
    dynamicClass: ".c-custom-chrono.dynamicLoading",
  },

  init: function () {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-customChrono.css", this.props.dynamicClass);

    document.querySelectorAll(".custom-chrono-JS").forEach(customChrono.process);
  },

  process: function ($component) {
    const startDate = new Date($component.dataset.startDate);
    const endDate = new Date($component.dataset.endDate);
    const now = Date.now();
    if (startDate < now && endDate > now) {
      customChrono.startUpdateLoop($component, endDate.getTime());
    } else if (startDate > now && endDate > now && startDate - now <= 21600000) {
      // 21600000ms = 6h
      setTimeout(customChrono.startUpdateLoop, startDate - now, $component, endDate.getTime());
    }
  },

  startUpdateLoop: function ($component, milliseconds) {
    const then = milliseconds;

    const updateCountdown = function () {
      const secondsLeft = Math.round((then - Date.now()) / 1000);
      if (secondsLeft <= 0) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        clearInterval(countdownInterval);
        customChrono.finish($component);
      }
      customChrono.displayTimeLeft($component, secondsLeft);
    };

    updateCountdown();
    $component.classList.remove("hidden");
    const countdownInterval = setInterval(updateCountdown, 1000);
  },

  finish: function ($component) {
    setTimeout(function () {
      $component.classList.add("hidden");
    }, 5000);
  },

  displayTimeLeft: function ($component, seconds) {
    const firstTime = [{}, {}, {}, {}];
    let showPrev = false;
    const timeCellsData = [
      {
        selector: ".days",
        value: Math.floor(seconds / 86400)
          .toString()
          .padStart(2, "0"),
      },
      {
        selector: ".hours",
        value: Math.floor((seconds % 86400) / 3600)
          .toString()
          .padStart(2, "0"),
      },
      {
        selector: ".minutes",
        value: Math.floor(((seconds % 86400) % 3600) / 60)
          .toString()
          .padStart(2, "0"),
      },
      { selector: ".seconds", value: (seconds % 60 < 10 ? "0" + (seconds % 60) : seconds % 60).toString().padStart(2, "0") },
    ];
    timeCellsData.forEach(function (timeCellData, i) {
      showPrev = customChrono.displayTimeLeftElement($component, timeCellData.selector, timeCellData.value, showPrev);
      if (timeCellData.value === 0) {
        if (timeCellsData[i - 1] && timeCellsData[i - 1].value === 0 && (!firstTime[i - 1] || !firstTime[i - 1].flag)) {
          firstTime[i - 1].flag = true;
        } else if (timeCellsData[i - 1] && timeCellsData[i - 1].value !== 0) {
          firstTime[i - 1].flag = null;
        }
      }
    });
  },

  displayTimeLeftElement: function ($component, selector, value, showPrev) {
    const $countdownTimeCell = $component.querySelector(selector);

    if (!$countdownTimeCell) {
      return false;
    }
    if (value || showPrev) {
      $countdownTimeCell.querySelector(".value").innerText = value;
      return true;
    }

    return false;
  },
};

export default customChrono;
